module.exports = __webpack_public_path__ + "ddce524caade84fca7776b7752eabaf3.pdf";